
<div *ngIf="paymentMethodsLoading" class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<div class="select-payment-method" *ngIf="!paymentMethodsLoading">
    <h5>{{'payment.payWith' | translate}}</h5>
    <mat-button-toggle-group [(ngModel)]="paymentProvider" (change)="changeMethod($event.value)"
        aria-label="Select an option">
        <ng-container *ngFor="let item of paymentMethods">
            <mat-button-toggle class="h-auto" [value]="item.code"
                [hidden]="!iOS() && item.code == onlinePaymentEnum.ApplePay">
                <img [src]="item.iconPath" />
                <span>{{item.name}}</span>
            </mat-button-toggle>
        </ng-container>
    </mat-button-toggle-group>
</div>

<div *ngIf="dataLoading" class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<iframe *ngIf="!dataLoading" class="payment-online-iframe w-100" [src]="referencePaymentUrl | safe"
    [class.loading]="paymentIframeLoader" (load)="paymentIframeLoader = false"></iframe>
